export default __webpack_public_path__ + "static/media/email.99add477.svg";